import {
  Epic,
  JiraProject,
  EpicsMap,
  StoriesMap,
  PublishJiraResponse,
  ServerError
} from '../../common/Types';
import { IJiraApiClient } from './JiraApiClient';

export default class JiraApiService {
  jiraApiClient: IJiraApiClient;

  constructor(jiraApiClient: IJiraApiClient) {
    this.jiraApiClient = jiraApiClient;
  }

  async loadEpics(currentProject: JiraProject): Promise<EpicsMap | ServerError> {
    return await this.jiraApiClient.loadEpics(currentProject);
  }

  async searchExistingEpics(currentProject: JiraProject, epicIds: string[]): Promise<Epic[]> {
    return await this.jiraApiClient.searchExistingEpics(currentProject, epicIds);
  }

  async getRecentProjects(): Promise<JiraProject | ServerError> {
    return await this.jiraApiClient.getRecentProject();
  }

  async publishEpicsAndStoriesToJira(
    newEpics: EpicsMap,
    jiraEpics: EpicsMap,
    stories: StoriesMap,
    currentProject: JiraProject
  ): Promise<PublishJiraResponse> {
    return await this.jiraApiClient.publishEpicsAndStoriesToJira(
      newEpics,
      jiraEpics,
      stories,
      currentProject
    );
  }
}
